import { Component, OnInit, ViewEncapsulation, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import  *  as  helpData  from  '../../data/help/compliance_lists.json';

//Service
import { DataService } from '../../services/data.service';

@Component({
    selector: 'app-compliance',
    templateUrl: './compliance.component.html',
    encapsulation: ViewEncapsulation.None
})
  
  export class ComplianceComponent implements OnInit {
    help: any;
    constructor(private http: HttpClient, private data: DataService){
              
    }

    ngOnInit() {
      this.data.currentHelp.subscribe(help => this.help = help);

    }

    ngAfterViewInit() {
      setTimeout(() => {  this.data.changeHelp(helpData["default"])});
    }
    
}